// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__XsxYj","cell":"ColumnAccessor_cell__cSAtk","firstCellAccent":"ColumnAccessor_firstCellAccent__2dQyJ"};